<template>
    <div class="left-nav-collapsible"> 
        <div v-if="detailPageOpen" id="detail-page-open" class="position-absolute">
            <button class="btn details-open-btn" type="button" @click="onDetailPageOpenClose(false)">
                <span> <i class="fa fa-caret-right"></i></span>
            </button>
        </div>
        <TransitionGroup :name="'slide'" key="detail">
            <div v-if="!detailPageOpen" id="details-col1" key="details-col1">
                <div class="card bg-white p-3">
                    <div class="d-flex justify-content-between align-items-center m-1">
                        <h4>Filter by Status</h4>
                        <button class="btn btn-sm btn-light" @click="onDetailPageOpenClose(true)">
                            <span class="fa fa-close"></span>
                        </button>
                    </div>
                    <div class="d-flex justify-content-between align-items-end mx-1 mb-1 gap-4">
                        <div class="status-input input-group input-group-sm">
                            <MultiSelect 
                                    class="form-control"
                                    :options="statusList"
                                    :editable="true" 
                                    v-model="status"
                                    :createOption="false"
                                />
                        </div>
                        <button class="btn btn-sm btn-primary" @click="readJobRunList" :disabled="readingJob">
                            <div v-if="readingJob" class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <div v-else>
                                Apply
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <div id="main-col" key="main-col">
                <div class="card">
                    <div class="row justify-content-end">                                    
                        <div  class="col-sm-3 d-flex position-absolute mt-3 me-3 justify-content-end" >
                            <div class="input-group input-group-sm">
                                <label class="input-group-text">Executions Limit</label>
                                <input type="number" class="form-control" aria-label="limit" v-model="$store.state.sandbox.executionsListLimit">
                                <button :disabled="jobRunList===null" class="btn btn-outline-secondary" type="button" @click="readJobRunList"><i class="fa fa-refresh" aria-hidden="true"></i></button>                    
                            </div>
                        </div>           
                    </div> 
                            
                    <datatable             
                        :tableId="`${job.name}-runhistory`" 
                        :columns="columns"
                        :formatColumn="formatColumn"
                        :data="jobRunList"      
                        :showLoading="jobRunList===null"       
                        :compact="true" 
                        :orderColumn="orderColumn"  
                        @viewModal="openModal" 
                        :viewModalColumn="viewModalColumn"            
                        :detailColumn="{renderBaseUrl: (data) => {
                                                                return `execution-details/${data.execution_id}`;                                                   
                                                            },}"
                    />
                </div>
            </div>
        </TransitionGroup>    
    </div>  
</template>

<script>
import Datatable from "../../../components/Datatable.vue";
import { mapActions, mapState } from "vuex";
import { secondsTohms } from '../../../utils/commonFunction';
import MultiSelect from '../../../components/MultiSelect.vue';
export default {
    name: "Run History",
    components: { Datatable, MultiSelect },
    data() {
        return {
            columns: [
                { data: "id"},
                { data: "status" },   
                { data: "logs" },          
                { data: "submitted_at", title: "submitted At"},
                { 
                    data: "run_time", 
                    title:"run time",
                    render: function (data, type, row) {
                        return secondsTohms(data)
                    },
                },
                { data: "tag" },
            ],
            orderColumn: [4, "desc"],
            formatColumn:[
                {
                    index:4,
                    type:"datetime"
                }
                
            ],
            viewModalColumn: 3, //view icon column number
            status: [],
            statusList: [
                {label: "SUBMITTED", value: "submitted"},
                {label: "RUNNING", value: "running"},
                {label: "SUCCEEDED", value: "succeeded"},
                {label: "FAILED", value: "failed"},
                {label: "CANCELLED", value: "cancelled"}
            ],
            detailPageOpen: true,
            showCloseBtn: true,
            readingJob: false,
        };
    },
    props:[
        "job",
        "isSandbox",
    ],  
    computed: {
        jobRunList() {
            let runList = this.$store.state.sandbox.sandboxJobRuns;
            if(runList) {
                const modifiedList = this.addStatusFlag(runList);
                return modifiedList;
            }
            return runList;
           
        }
    },
    methods: {
      ...mapActions({
            showModal: "showModal",
            fetchJobRuns: "amdp/fetchJobRuns",
            fetchSandboxJobRuns: "sandbox/fetchSandboxJobRuns",         
        }),
        async readJobRunList() {
            if (!this.job.name)
                return; 
            let self = this;   
            let response;
            this.readingJob = true;
            try {
                response = await this.fetchSandboxJobRuns({jobName:this.job.name, limit:this.$store.state.sandbox.executionsListLimit, status:this.status});
            } catch (error) {
                if(error.response.status == 504) {
                    const options = {
                        message: "We’re sorry, but we’re having trouble processing your request.. Please try refreshing the list by setting limit to lower value",
                        type: "error",
                    };
                    this.$store.dispatch("addToast", options);
                } else {
                    if (error.response && error.response.data.error)
                        this.error = error.response.data.error;
                    else this.error = error.message;

                    let toastOptions = {
                        message: this.error || "Something went wrong while fetching executions list. Please contact support.",
                        type: "error",
                    };
                    this.$store.dispatch("addToast", toastOptions);      
                }
                return;
            } finally {
                this.readingJob = false;
            }          
        },
        addStatusFlag(list) {
            let modifiedList = [];
            list.map((job)=>{
                    let status ="";
                    if(job.status.toLowerCase()==="succeeded"){
                        status = "<span class='text-success'>●</span> ";
                    } else if(job.status.toLowerCase()==="failed"){
                        status = "<span class='text-danger'>●</span> ";
                    } else if(job.status.toLowerCase()==="running"){
                        status = "<span class='text-primary'>●</span> ";
                    } else if(job.status.toLowerCase()==="submitted"){
                        status = "<span class='text-warning'>●</span> ";
                    } else if(job.status.toLowerCase()==="cancelled"){
                        status = "<span class='text-secondary'>●</span> ";
                    }
                    job["status"] = status + job.status;
                    modifiedList.push(job);
                });
            return modifiedList;
        },
        openModal(data){
            this.showModal({component:"ViewLog",data:{
                sandboxName:this.$store.state.sandbox.currentSandbox, jobName:this.job.name, executionId:data.execution_id,
                screenlarge: true,
                status:data.status.match(/\brunning\b/i)?"running":""
            }})
        },
        onDetailPageOpenClose(value) {
            this.showCloseBtn = false;
            this.detailPageOpen = value;
        },

    },       
    mounted() {  
        this.$emit('hideEdit', true);
        this.$emit('hideRunJob', true);
        this.$emit('hidePromoteBtn', true);
        this.$emit('showOverrideEdit', false);
        this.$emit('setOverrideEditMode', false);
    },
    emits: ['hideEdit', 'hideRunJob', 'hidePromoteBtn', 'showOverrideEdit', 'setOverrideEditMode']  

}
</script>

<style scoped>
.status-input {
    min-width: 300px;
    width: auto;
    max-width: 100%;
}
.spinner-border {
	width: 1em;
	height: 1em;
}
</style>